import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f930e7e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-jc-end p-mt-2"
}
const _hoisted_3 = { class: "pointer" }
const _hoisted_4 = {
  key: 1,
  class: "p-mb-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-error f-size-14"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "p-d-flex p-mt-3" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "sameReceiptCheckbox"
}, "ใช้ที่อยู่เดียวกับที่อยู่ในการจัดส่ง", -1))
const _hoisted_10 = { class: "p-d-flex p-mt-1" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "getTaxReceiptCheckbox"
}, "ออกใบกำกับภาษี", -1))
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "p-grid p-mt-2" }
const _hoisted_15 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_16 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_17 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_18 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "pointer text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_ShippingAddressDetailForm2 = _resolveComponent("ShippingAddressDetailForm2")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!
  const _component_BillingAddressDetailForm2 = _resolveComponent("BillingAddressDetailForm2")!
  const _component_ModalAlertError = _resolveComponent("ModalAlertError")!
  const _component_ModalAddAdress2 = _resolveComponent("ModalAddAdress2")!
  const _component_ModalAddAddressBliing = _resolveComponent("ModalAddAddressBliing")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSelfPick)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("u", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModalAddAddress(_ctx.address)))
            }, "ที่อยู่ของฉัน")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSelfPick)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.selfPickupAddress,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selfPickupAddress) = $event)),
              onKeyup: _ctx.setSelfPickupAddress,
              rows: "3",
              class: "w-100"
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          (!_ctx.selfPickupAddress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " กรุณากรอกที่อยู่ในการรับสินค้า "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSelfPick)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.changeTransaction)
            ? (_openBlock(), _createBlock(_component_ShippingAddressDetailForm2, {
                key: 0,
                v: _ctx.v.shippingAddress,
                transaction: _ctx.transaction
              }, null, 8, ["v", "transaction"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.transaction.buyerInfo.sameAddress) = $event)),
            type: "checkbox",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSameAddressChange && _ctx.handleSameAddressChange(...args))),
            class: "form-check-input",
            id: "sameReceiptCheckbox"
          }, null, 544), [
            [_vModelCheckbox, _ctx.transaction.buyerInfo.sameAddress]
          ]),
          _hoisted_9
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice) = $event)),
            type: "checkbox",
            class: "form-check-input",
            id: "getTaxReceiptCheckbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice]
          ]),
          _hoisted_12
        ])
      ])
    ]),
    (_ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_InputSelect, {
                title: "คำนำหน้าชื่อ",
                text: "คำนำหน้าชื่อ",
                name: "nameTitleId",
                valueField: "id",
                textField: "name",
                placeholder: "กรุณาเลือก",
                options: _ctx.nameTitleList,
                onOnDataChange: _ctx.onNameTitleChange,
                "model-value": _ctx.transaction.buyerInfo.billingAddress.nameTitleId,
                v: _ctx.v.billingAddress.nameTitleId,
                isValidate: _ctx.v.billingAddress.nameTitleId.$error,
                isRequired: "",
                ref: "saleChanelId"
              }, null, 8, ["options", "onOnDataChange", "model-value", "v", "isValidate"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_InputTextCustom, {
                "model-value": _ctx.transaction.buyerInfo.billingAddress.firstname,
                textFloat: _ctx.titleFirstname,
                placeholder: _ctx.titleFirstname,
                type: "text",
                name: "nameOrCompanyName",
                isRequired: "",
                v: _ctx.v.billingAddress.firstname,
                isValidate: _ctx.v.billingAddress.firstname.$error,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
              _ctx.transaction.buyerInfo.billingAddress.firstname = $event
            )),
                class: "f-regular"
              }, null, 8, ["model-value", "textFloat", "placeholder", "v", "isValidate"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_InputTextCustom, {
                "model-value": _ctx.transaction.buyerInfo.billingAddress.lastname,
                textFloat: _ctx.titleLastname,
                placeholder: _ctx.titleLastname,
                type: "text",
                name: "lastname",
                isRequired: "",
                v: _ctx.v.billingAddress.lastname,
                isValidate: _ctx.v.billingAddress.lastname.$error,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (
              _ctx.transaction.buyerInfo.billingAddress.lastname = $event
            )),
                class: "f-regular"
              }, null, 8, ["model-value", "textFloat", "placeholder", "v", "isValidate"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_InputTextCustom, {
                "model-value": _ctx.transaction.buyerInfo.billingAddress.tax,
                textFloat: "เลขประจำตัวผู้เสียภาษี ",
                placeholder: "เลขประจำตัวผู้เสียภาษี ",
                type: "text",
                name: "tax",
                isRequired: "",
                v: _ctx.v.billingAddress.tax,
                isValidate: _ctx.v.billingAddress.tax.$error,
                maxlength: 13,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (
              _ctx.transaction.buyerInfo.billingAddress.tax = $event
            )),
                class: "f-regular"
              }, null, 8, ["model-value", "v", "isValidate"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (
        !_ctx.transaction.buyerInfo.sameAddress ||
        _ctx.transaction.buyerInfo.userInfo.isRequestTaxInvoice
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("u", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModalAddAddressBilling(_ctx.address)))
            }, "ที่อยู่ของฉัน")
          ]),
          _createVNode(_component_BillingAddressDetailForm2, {
            v: _ctx.v.billingAddress,
            transaction: _ctx.transaction
          }, null, 8, ["v", "transaction"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalAlertError, {
      modalMessage: _ctx.modalMessage,
      onOnHideModalError: _ctx.onHideModalError,
      ref: "modalAlertError"
    }, null, 8, ["modalMessage", "onOnHideModalError"]),
    _createVNode(_component_ModalAddAdress2, {
      ref: "modalAddAdress2",
      address: _ctx.addressSelected,
      sessionId: _ctx.sessionId,
      transaction: _ctx.transaction,
      addressList: _ctx.addressList,
      onHandleSelectAddress: _ctx.handleSelectAddress,
      onGetAddressList: _ctx.getAddressList,
      onOnDeleteAddress: _ctx.onDeleteAddress
    }, null, 8, ["address", "sessionId", "transaction", "addressList", "onHandleSelectAddress", "onGetAddressList", "onOnDeleteAddress"]),
    _createVNode(_component_ModalAddAddressBliing, {
      ref: "modalAddAddressBilling",
      address: _ctx.addressSelected,
      sessionId: _ctx.sessionId,
      transaction: _ctx.transaction,
      addressList: _ctx.addressList,
      onHandleSelectAddress: _ctx.handleSelectBillingAddress,
      onGetAddressList: _ctx.getAddressList,
      onOnDeleteAddress: _ctx.onDeleteAddress
    }, null, 8, ["address", "sessionId", "transaction", "addressList", "onHandleSelectAddress", "onGetAddressList", "onOnDeleteAddress"])
  ]))
}